<template>
    <DCard
        padding
    >
        <Form
            :domain-configuration="domainConfiguration"
            :errors="errors"
            :schema="schema"
            :idn-character-sets="idnCharacterSets"
            :selected-idn-character-sets="selectedIdnCharacterSets"
            @form-submitted="submitForm"
        />
    </DCard>
</template>

<script setup>
import Form from '~@/Components/Settings/DomainConfiguration/Form'
import { route } from '~@/Composables/route'

const props = defineProps({
    domainConfiguration: {
        type: Object,
        default: () => { return {} }
    },
    errors: {
        type: Object,
        default: () => { return {} }
    },
    schema: {
        type: Object,
        default: () => { return {} }
    },
    idnCharacterSets: {
        type: Array,
        default: () => { return [] }
    },
    selectedIdnCharacterSets: {
        type: Array,
        default: () => { return [] }
    }
})

const submitForm = (form) => {
    form.patch(route('settings.domain-configuration.update', {
        domain_configuration: props.domainConfiguration.id
    }))
}
</script>
